import { render, staticRenderFns } from "./group-detail-insights.vue?vue&type=template&id=57c32cc8&"
import script from "./group-detail-insights.ts?vue&type=script&lang=js&"
export * from "./group-detail-insights.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports